import { render, staticRenderFns } from "./DeleteDepartmentDialog.vue?vue&type=template&id=e6cfc42e&scoped=true&"
import script from "./DeleteDepartmentDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDepartmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDepartmentDialog.vue?vue&type=style&index=0&id=e6cfc42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cfc42e",
  null
  
)

export default component.exports